const testimonials = [
  {
    name: 'James W.',
    location: 'Johnson City, TN',
    rating: 5,
    text: "Had Holston come out to mulch about 2.5 acres of overgrown land to expand our pasture. They got it done in a single day. Property looks completely different. Would use them again.",
    project: 'Forestry Mulching',
  },
  {
    name: 'Sarah M.',
    location: 'Kingsport, TN',
    rating: 5,
    text: "Our gravel driveway washed out every time we got a heavy rain. Holston came out, repaired and regraded the whole thing, and saved us a lot of money by reusing material we didn\'t even realize was already there. Haven\'t had a single washout since.",
    project: 'Driveway Regrading',
  },
  {
    name: 'Kevin D.',
    location: 'Baldwin, MI',
    rating: 5,
    text: "We bought a lot and needed it cleared, graded, and prepped before our builder could start. Holston handled all of it. By the time they were done, the site was ready to go and our builder said it was one of the cleanest site preps he\'d worked on.",
    project: 'Site Preparation',
  },
];

export default function HomeTestimonials() {
  return (
    <section className="w-full bg-brand-black py-24 px-6 lg:px-12">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">Client Reviews</p>
          <h2 className="font-heading font-800 text-white text-5xl md:text-6xl tracking-widest uppercase mb-4">
            What Clients Say
          </h2>
          <div className="w-12 h-0.5 bg-brand-green-accent mx-auto" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-brand-charcoal border border-brand-charcoal-mid p-8 flex flex-col gap-5"
            >
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-brand-green-accent text-sm" />
                  </div>
                ))}
              </div>

              {/* Quote */}
              <p className="font-body text-sm text-gray-300 leading-relaxed italic flex-1">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Divider */}
              <div className="w-8 h-px bg-brand-green-mid" />

              {/* Name */}
              <div>
                <p className="font-heading font-700 text-white text-base tracking-wider uppercase">
                  {t.name}
                </p>
                <p className="font-body text-xs text-gray-500 mt-1">{t.location}</p>
                <p className="font-body text-xs text-brand-green-accent mt-1">{t.project}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
